import {Route, Switch, withRouter} from "react-router-dom";
import React, {Component, Fragment} from "react";
import Register from "../views/Unauthenticated/Register/Register";
import Login from "../views/Unauthenticated/Login";
import ForgotPassword from "../views/Unauthenticated/ForgotPassword/ForgotPassword";
import RegisterV2 from "views/Unauthenticated/Registerv2/RegisterV2";
import InboundFollowUpFlow from "../views/Authenticated/InboundFollowUp/InboundFollowUpFlow";
import InboundTransactionSearch from "../views/Unauthenticated/InboundTransactionSearch/InboundTransactionSearch";

class UnauthenticatedRouter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false
        };
    }

    render() {

        return (
            <Fragment>
                <Switch>

                    <Route path={"/inbound-redemption-follow-up"}>
                        <InboundFollowUpFlow
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path={"/redeem-inbound-transaction"}>
                        <RegisterV2
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/forgot-password">
                        <ForgotPassword {...this.props.childProps}/>
                    </Route>
                    <Route path="/register">
                        <Register {...this.props.childProps}/>
                    </Route>
                    <Route path="/inbound-transaction-search/contact-us">
                        <InboundTransactionSearch
                            {...this.props.childProps}
                            isContactUsShowing={true}
                            baseUrl={"/inbound-transaction-search"}
                        />
                    </Route>
                    <Route path="/inbound-transaction-search/:remittancePartner">
                        <InboundTransactionSearch
                            {...this.props.childProps}
                            baseUrl={"/inbound-transaction-search/:remittancePartner"}
                        />
                    </Route>
                    <Route path="">
                        <Login
                            {...this.props.childProps}
                        />
                    </Route>
                </Switch>
            </Fragment>
        );
    }
}

export default withRouter(UnauthenticatedRouter);
